import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

 

  return (
    <div className="shop main">
      <div className="shop-header">
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <svg className="separator" viewBox="0 0 16 16" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M6 12l4-4-4-4" />
          </svg>
          <span className="current">New Arrivals</span>
        </div>
        <h1 className="title">New Arrivals</h1>
      </div>

      <div className="product-grid">
        {productData.map((product) => (
          <div className="product-card" key={product.id}>
            <Link to={`/shopDetails/${product.id}`} onClick={toTop} className="image-link">
              <div className="image-wrapper">
                <img src={product.image} alt={product.name} />
              </div>
            </Link>
            <div className="product-info">
              <div className="info-top">
                <h3 className="product-name">{product.name.toUpperCase()}</h3>
               
              </div>
              <div className="info-bottom">
                <span className="product-price">${product.price}</span>
                 
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Shop;
